import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  justify-content: left;
  height: 1.63em;
  background-color: #f0f6eb;
  border-left: 0.3em solid #4e8130;  
  margin-bottom: 0.35em; 
  font-family: Helvetica;
  font-size: 13px;  
  text-align: left;  
  overflow: hidden;
`;

const Text = styled.div`
  width: 11em;
  height: 16px;    
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.82em;
  letter-spacing: normal;  
  margin: 0 0.63em 0 0.63em;
`;

/**
 * @tags styled, TariffInfo
 */
function TariffInfo(props) {
  return (
    <Wrapper>
      <Text>
        <b>{props.data.value}</b>
        {' '}
        {props.data.label}
      </Text>
    </Wrapper>
  );
}

TariffInfo.propTypes = {
  data: PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }).isRequired
};

TariffInfo.displayName = 'TariffInfo';

/** @component */
export default TariffInfo;
